import {
  DWEB_MINI_COUPONS_OFFERS,
  DWEB_MULTICOUPON_EXP,
} from 'constants/product';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { useSelector } from 'react-redux';
import { State } from 'store/types';

export const useCouponEligibility = () => {
  const isMultiCouponEnabled =
    useSelector((state: State) =>
      getEligibleForVariant(state, DWEB_MULTICOUPON_EXP, 'A')
    ) || true;
  return isMultiCouponEnabled;
};

export const useMiniCouponsAndOffersEligibility = () => {
  const isMiniCouponsAndOfferEnabled =
    useSelector((state: State) =>
      getEligibleForVariant(state, DWEB_MINI_COUPONS_OFFERS, 'A')
    ) || false;
  return isMiniCouponsAndOfferEnabled;
};
